module.exports = __webpack_public_path__ + "media/pc唤醒回应.a823cb30.mp3";